import { Link } from 'react-router-dom';
import './Footer.css';

const productLinks = [
  { caption: 'Robohound AI Hub', url: 'https://robohound.ai', external: true },
  { caption: 'IntelliMatcher', url: 'https://intellimatcher.robohound.ai', external: true },
  { caption: 'Medibotx', url: 'https://www.medibotx.com', external: true },
  { caption: 'Smart Performance Analytics', url: 'https://smartperformanceanalytics.smart-wares.com', external: true },
  { caption: 'Smart Case Management', url: '/products/case-management' },
  { caption: '247Shift.com', url: 'https://www.247shift.com', external: true },
];

const solutionLinks = [
  { caption: 'Enterprise Solutions', url: '/solutions' },
];

const companyLinks = [
  { caption: 'About Us', url: '/company/' },
  { caption: 'Consultancy', url: '/consultancy/' },
  { caption: 'Support', url: '/support/' },
  { caption: 'Contact Us', url: '/contact/' },
];

const legalLinks = [
  { caption: 'Legal Notices', url: '/legal/' },
  { caption: 'Privacy Policy', url: '/privacy/' },
];

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-brand-col">
            <Link to="/" className="footer-brand">
              <span className="footer-logo-icon">SW</span>
              <span className="footer-logo-text">SMART-WARES</span>
            </Link>
            <p className="footer-tagline">Smart, reliable software solutions for enterprise businesses — by SMART-WARES.</p>
            <address className="footer-address">
              212A Tanjong Katong Road<br />
              Singapore 437005
            </address>
          </div>

          {/* Solutions Column */}
           <div className="footer-col">
             <h4 className="footer-heading">Solutions</h4>
             <ul className="footer-links">
               {solutionLinks.map((item) => (
                 <li key={item.url}>
                   <Link to={item.url} className="footer-link">{item.caption}</Link>
                 </li>
               ))}
             </ul>
           </div>

           {/* Products Column */}
           <div className="footer-col">
             <h4 className="footer-heading">Products</h4>
             <ul className="footer-links">
               {productLinks.map((item) => (
                 <li key={item.url}>
                   {item.external ? (
                     <a href={item.url} target="_blank" rel="noopener noreferrer" className="footer-link">
                       {item.caption} <span className="external-icon" aria-hidden="true">↗</span>
                     </a>
                   ) : (
                     <Link to={item.url} className="footer-link">{item.caption}</Link>
                   )}
                 </li>
               ))}
             </ul>
           </div>

          {/* Company Column */}
          <div className="footer-col">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              {companyLinks.map((item) => (
                <li key={item.url}>
                  <Link to={item.url} className="footer-link">{item.caption}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Column */}
          <div className="footer-col">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              {legalLinks.map((item) => (
                <li key={item.url}>
                  <Link to={item.url} className="footer-link">{item.caption}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {currentYear} SMART-WARES. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
